var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"label":"text","track-by":"value","placeholder":_vm.placeholder,"close-on-select":true,"disabled":_vm.readonly,"showLabels":false,"multiple":false,"options":_vm.options},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }